/** /blacklists — two tabs: delivery blacklist rules and system event groups. */
import { Box, Tab, Tabs } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

import { PageHeader } from '@/components/PageHeader';

import { BlacklistsGrid } from './BlacklistsGrid';
import { EventGroupsGrid } from './EventGroupsGrid';

const TABS = [
  { id: 'rules', label: 'Blacklists' },
  { id: 'event-groups', label: 'Event groups' },
] as const;
type TabId = (typeof TABS)[number]['id'];

function TabPane({
  id,
  active,
  children,
}: {
  id: TabId;
  active: TabId;
  children: React.ReactNode;
}) {
  if (id !== active) return null;
  return <Box sx={{ mt: 2 }}>{children}</Box>;
}

export function BlacklistsPage() {
  const params = useParams<{ tab?: string }>();
  const navigate = useNavigate();
  const activeTab: TabId = TABS.some((t) => t.id === params.tab) ? (params.tab as TabId) : 'rules';

  return (
    <>
      <PageHeader
        helpStory="notification-blacklists"
        section={TABS.find((t) => t.id === activeTab)?.label}
        title="Blacklists"
        subtitle="Block notification delivery to specific destinations, and manage the event groups rules can reference."
      />
      <Tabs value={activeTab} onChange={(_, v) => navigate(`/blacklists/${v as TabId}`)}>
        {TABS.map((t) => (
          <Tab key={t.id} value={t.id} label={t.label} />
        ))}
      </Tabs>
      <TabPane id="rules" active={activeTab}>
        <BlacklistsGrid />
      </TabPane>
      <TabPane id="event-groups" active={activeTab}>
        <EventGroupsGrid />
      </TabPane>
    </>
  );
}
